import { format } from "d3-format";
import React, { Component } from "react";
import PropTypes from "prop-types";

import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";
import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";
import { functor } from "../utils";

class KSTTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }

  renderSVG(moreProps) {
    const { onClick, fontFamily, fontSize, displayFormat, className } =
      this.props;
    const { yAccessor, options, appearance, labelFill } = this.props;
    const { displayValuesFor } = this.props;

    const {
      chartConfig: { width, height },
    } = moreProps;

    const currentItem = displayValuesFor(this.props, moreProps);
    const kstValue = currentItem && yAccessor(currentItem);

    const kst =
      (kstValue && kstValue.kst != null && displayFormat(kstValue.kst)) ||
      "n/a";
    const signal =
      (kstValue && kstValue.signal != null && displayFormat(kstValue.signal)) ||
      "n/a";

    const { origin: originProp } = this.props;
    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    const kstColor = appearance?.strokeKST?.color || "#00DD00";
    const signalColor = appearance?.strokeSignal?.color || "#FF0000";

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-kst"
      >
        <ToolTipText x={0} y={0} fontFamily={fontFamily} fontSize={fontSize}>
          <ToolTipTSpanLabel fill={labelFill}>KST: </ToolTipTSpanLabel>
          <tspan fill={kstColor}>{kst}</tspan>
          <ToolTipTSpanLabel fill={labelFill}> Signal (</ToolTipTSpanLabel>
          <tspan fill={signalColor}>{options?.signal || 9}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>): </ToolTipTSpanLabel>
          <tspan fill={signalColor}>{signal}</tspan>
        </ToolTipText>
      </g>
    );
  }

  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

KSTTooltip.propTypes = {
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  className: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  labelFill: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  options: PropTypes.object,
  appearance: PropTypes.object,
  displayFormat: PropTypes.func.isRequired,
  displayValuesFor: PropTypes.func.isRequired,
  onClick: PropTypes.func,
};

KSTTooltip.defaultProps = {
  origin: [0, 0],
  className: "react-stockcharts-tooltip",
  displayFormat: format(".2f"),
  displayValuesFor: displayValuesFor,
  labelFill: "#4a4a4a",
  fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
  fontSize: 12,
};

export default KSTTooltip;
